export default __webpack_public_path__ + "static/media/wine-flights.fe4bb6fb.png";